import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import Logo from "../../components/Logo";
import {data} from "../../data/data";


export const Select = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!data.paymentMethods) {
      navigate(`/`, {replace: true});
    }
  }, [navigate]);

  if (!data.paymentMethods) {
    return <></>
  }

  return (
    <div className="main-container">
      <div className="outer">
        <Logo />
        <div className="inner">
          <h1>{t('Select a method:')}</h1>
          <ul className="integration-list">
            {
              data.paymentMethods?.map(method => <li key={method.type} className="integration-list-item">
                <Link to={`/payment/${method.type}`} className="integration-list-item-link">
                  <div className="title-container">
                    <p className="integration-list-item-title">{method.name}</p>
                  </div>
                </Link>
              </li>)
            }
          </ul>
        </div>
      </div>
    </div>
  )
}
